
import styles from "./footer.module.css";
import {useI18N} from "@/context/I18NContext";
import React from 'react';
import { useConfig } from "@/context/ConfigContext";
import {FaInstagram, FaWhatsapp, FaLinkedin, FaFacebookF} from "react-icons/fa";
import { FitLayout } from "@/components/fitLayout";

export const Footer = () => {
  const {t} = useI18N();
  const config = useConfig();

  return (
      <div className={styles.footer}>
        <FitLayout>
        <div className={styles.footer_content}>
          <div className={styles.footer_copyright}>{config.footer.copyright}</div>
          <div className={styles.footer_legal}>
            <div className={styles.footer_legal_links}>
              <a className={styles.footer_legal_item} href="/legal/privacity" title={t('privacity')}>
                {t('privacity')}
              </a>
              <a className={styles.footer_legal_item} href="/legal/cookies-policy" title={t('cookies-policy')}>
                {t('cookies-policy')}
              </a>
              <a className={styles.footer_legal_item} href="/legal/legal_notice" title={t('legal_notice')}>
                {t('legal_notice')}
              </a>
            </div>
          </div>
          {config.footer.rrss &&
            <div className={styles.footer_social}>
              {Object.keys(config.footer.rrss).map((rrssKey : string) => 
                <a className={styles.footer_social_item} key={rrssKey} href={config.footer.rrss[rrssKey]} target="_blank">
                    {rrssKey == 'instagram' && <FaInstagram />}
                    {rrssKey == 'whatsapp' && <FaWhatsapp />}
                    {rrssKey == 'linkedin' && <FaLinkedin />}
                    {rrssKey == 'facebook' && <FaFacebookF />}
                  </a>
              )}
            </div>
          }
        </div>
        {config.footer.made_with?.link_disabled != true && <a className={styles.made_by} href='https://keperin.com' target="_blank">Made with ❤️ by Keperin</a>}
        {config.footer.made_with?.link_disabled && <div className={styles.made_by}>Made with ❤️ by Keperin</div>}
        </FitLayout>
      </div>
    
  );
};
